import { ToastContext } from '@/utils/common-utils';
import { useState, useEffect } from 'react';

export const ToastProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [toastMessage, setToastMessage] = useState<string>('');
  const [timeoutId, setTimeoutId] = useState<NodeJS.Timeout | null>(null);

  const showToast = (message: string) => {
    setToastMessage(message);
    if (timeoutId) clearTimeout(timeoutId);
    const id = setTimeout(() => setToastMessage(''), 3000);
    setTimeoutId(id);
  };

  useEffect(() => {
    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [timeoutId]);

  return (
    <ToastContext.Provider value={showToast}>
      {children}
      {toastMessage && (
        <div className="fixed top-5 right-5 bg-gray-900 text-white p-3 rounded-lg shadow-lg z-50">
          {toastMessage}
          <button className="ml-3 text-red-400 cursor-pointer" onClick={() => setToastMessage('')}>
            X
          </button>
        </div>
      )}
    </ToastContext.Provider>
  );
};
